import { addActionsFromArgTypes, inferActionsFromArgTypesRegex } from './addArgsHelpers';
export var argsEnhancers = [addActionsFromArgTypes, inferActionsFromArgTypesRegex];